// 常用支付方式dlg组件

const commonPayDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    branchId: '',

    payId: '',

    payInfo: {},
  },

  getters: {
    dlgShow: state => state.dlgShow,

    branchId: state => state.branchId,

    payId: state => state.payId,

    payInfo: state => state.payInfo
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_BRANCHID: (state, val) => {
      state.branchId = val
    },

    SET_PAYID: (state, val) => {
      state.payId = val
    },

    SET_PAYINFO: (state, val) => {
      state.payInfo = val
    }
  },

  actions: {

  }
}

export default commonPayDlg
